import imagesLoaded from 'vue-images-loaded'
import Vue from 'vue'

Vue.directive('images-loaded', imagesLoaded);